import type { FeatureNames } from "./feature-names";

/** Spanish names of the staff features and settings categories. Same keys as features.fr.ts. */
export const featuresEs: FeatureNames = {
  features: {
    SEARCH_ACCOUNTS_STAFF_FEATURE_ENABLEMENT: "Buscar cuentas",
    VIEW_ACCOUNTS_STAFF_FEATURE_ENABLEMENT: "Ver una cuenta",
    REVEAL_CONTACT_DETAILS_STAFF_FEATURE_ENABLEMENT: "Mostrar un número",
    EDIT_CUSTOMER_SETTINGS_STAFF_FEATURE_ENABLEMENT: "Modificar los ajustes de un cliente",
    CLAIM_CASES_STAFF_FEATURE_ENABLEMENT: "Tomar expedientes",
    REASSIGN_CASES_STAFF_FEATURE_ENABLEMENT: "Reasignar expedientes",
    ACT_ON_BEHALF_STAFF_FEATURE_ENABLEMENT: "Actuar en nombre de un cliente",
    CORRECT_ACCOUNT_DETAILS_STAFF_FEATURE_ENABLEMENT: "Corregir los datos de una cuenta",
    REVIEW_VERIFICATIONS_STAFF_FEATURE_ENABLEMENT: "Revisar las verificaciones",
    VIEW_ID_IMAGES_STAFF_FEATURE_ENABLEMENT: "Ver las imágenes de identidad",
    APPROVE_PROS_STAFF_FEATURE_ENABLEMENT: "Aprobar pros",
    VIEW_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "Ver los pagos",
    ISSUE_REFUNDS_STAFF_FEATURE_ENABLEMENT: "Reembolsar",
    ISSUE_CREDITS_STAFF_FEATURE_ENABLEMENT: "Conceder un abono",
    WAIVE_FEES_STAFF_FEATURE_ENABLEMENT: "Anular tarifas",
    MARK_PAYMENTS_PAID_STAFF_FEATURE_ENABLEMENT: "Marcar un pago como pagado",
    MANAGE_PLAN_PRICES_STAFF_FEATURE_ENABLEMENT: "Fijar los precios de los planes",
    RUN_PROMOS_STAFF_FEATURE_ENABLEMENT: "Lanzar promociones",
    OFFER_DISCOUNTS_STAFF_FEATURE_ENABLEMENT: "Conceder descuentos",
    MANAGE_SUBSCRIPTIONS_STAFF_FEATURE_ENABLEMENT: "Alargar o terminar una suscripción",
    APPROVE_PAYMENT_REQUESTS_STAFF_FEATURE_ENABLEMENT: "Aprobar por encima del límite",
    RECONCILE_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "Conciliar los pagos",
    EXPORT_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "Exportar",
    HANDLE_REPORTS_STAFF_FEATURE_ENABLEMENT: "Gestionar las denuncias",
    SET_REPORT_SEVERITY_STAFF_FEATURE_ENABLEMENT: "Fijar la gravedad de una denuncia",
    SUSPEND_PENDING_INVESTIGATION_STAFF_FEATURE_ENABLEMENT: "Suspensión provisional",
    ISSUE_VERDICTS_STAFF_FEATURE_ENABLEMENT: "Emitir un veredicto",
    BAN_PERMANENTLY_STAFF_FEATURE_ENABLEMENT: "Vetar de forma definitiva",
    HANDLE_APPEALS_STAFF_FEATURE_ENABLEMENT: "Gestionar los recursos",
    REFER_TO_POLICE_STAFF_FEATURE_ENABLEMENT: "Remitir a la policía",
    SHARE_DATA_WITH_POLICE_STAFF_FEATURE_ENABLEMENT: "Compartir datos con la policía",
    PLACE_LEGAL_HOLDS_STAFF_FEATURE_ENABLEMENT: "Congelar pruebas",
    MODERATE_REVIEWS_STAFF_FEATURE_ENABLEMENT: "Moderar las reseñas",
    SEND_SMS_STAFF_FEATURE_ENABLEMENT: "Enviar un SMS",
    SEND_BULK_SMS_STAFF_FEATURE_ENABLEMENT: "Enviar SMS masivos",
    EDIT_SMS_TEMPLATES_STAFF_FEATURE_ENABLEMENT: "Modificar las plantillas de SMS",
    MANAGE_APP_FEATURES_STAFF_FEATURE_ENABLEMENT: "Gestionar las funciones de la app",
    EDIT_RULES_STAFF_FEATURE_ENABLEMENT: "Modificar las reglas",
    EDIT_PRICING_STAFF_FEATURE_ENABLEMENT: "Modificar las tarifas",
    EDIT_CATEGORIES_STAFF_FEATURE_ENABLEMENT: "Modificar los oficios",
    INVITE_STAFF_STAFF_FEATURE_ENABLEMENT: "Invitar al equipo",
    DEACTIVATE_STAFF_STAFF_FEATURE_ENABLEMENT: "Desactivar a un miembro",
    END_STAFF_SESSIONS_STAFF_FEATURE_ENABLEMENT: "Cerrar las sesiones",
    MANAGE_TEAMS_STAFF_FEATURE_ENABLEMENT: "Gestionar equipos",
    MANAGE_ROLES_STAFF_FEATURE_ENABLEMENT: "Gestionar los roles",
    MANAGE_ACTION_ENABLEMENTS_STAFF_FEATURE_ENABLEMENT: "Gestionar activaciones de acciones",
    ASSIGN_ROLES_STAFF_FEATURE_ENABLEMENT: "Asignar roles",
    MANAGE_LEADS_STAFF_FEATURE_ENABLEMENT: "Ventas y crecimiento",
    VIEW_MARKETPLACE_STAFF_FEATURE_ENABLEMENT: "Operaciones del mercado",
    MANAGE_HUMAN_RESOURCES_STAFF_FEATURE_ENABLEMENT: "Recursos humanos",
    VIEW_AUDIT_LOG_STAFF_FEATURE_ENABLEMENT: "Consultar el registro de auditoría",
    VIEW_SENSITIVE_AUDIT_VALUES_STAFF_FEATURE_ENABLEMENT: "Ver los valores sensibles",
    VIEW_HEALTH_DASHBOARD_STAFF_FEATURE_ENABLEMENT: "Ver el panel",
  },
  /** The permissions that sit on those features (ADR-0019), by settingId. */
  permissions: {
    ISSUE_REFUND_STAFF_PERMISSION: "Emitir un reembolso",
    SETTLE_REFUND_STAFF_PERMISSION: "Liquidar un reembolso",
    ISSUE_CREDIT_STAFF_PERMISSION: "Emitir un crédito",
    WAIVE_FEE_STAFF_PERMISSION: "Anular una tarifa",
    REPLY_TO_CUSTOMER_STAFF_PERMISSION: "Responder a un cliente",
    CLOSE_CASE_STAFF_PERMISSION: "Cerrar un expediente",
  },
  /** Customer features (Fonctionnalités), by settingId. */
  customerFeatures: {
    SEARCH_PROS_USER_FEATURE_ENABLEMENT: "Buscar profesionales",
    NEARBY_PROS_USER_FEATURE_ENABLEMENT: "Profesionales cercanos",
    REQUEST_PRO_USER_FEATURE_ENABLEMENT: "Pedir un profesional",
    POST_OPEN_JOB_USER_FEATURE_ENABLEMENT: "Publicar una solicitud abierta",
    JOB_PHOTOS_USER_FEATURE_ENABLEMENT: "Fotos en una solicitud",
    SELECT_QUOTE_USER_FEATURE_ENABLEMENT: "Elegir un presupuesto",
    LEAVE_REVIEWS_USER_FEATURE_ENABLEMENT: "Dejar una reseña",
    REQUEST_CALLBACK_USER_FEATURE_ENABLEMENT: "Pedir que te llamen",
    SAVE_FAVORITE_PROS_USER_FEATURE_ENABLEMENT: "Profesionales favoritos",
    REBOOK_PRO_USER_FEATURE_ENABLEMENT: "Volver a contratar a un profesional",
    SHARE_PRO_PROFILE_USER_FEATURE_ENABLEMENT: "Compartir el perfil de un profesional",
    SCHEDULE_JOB_USER_FEATURE_ENABLEMENT: "Programar una solicitud",
    URGENT_JOB_USER_FEATURE_ENABLEMENT: "Solicitud urgente",
    BECOME_PRO_USER_FEATURE_ENABLEMENT: "Hacerse profesional",
    LEAD_PREFERENCES_USER_FEATURE_ENABLEMENT: "Preferencias de oportunidades",
    EDIT_RATES_USER_FEATURE_ENABLEMENT: "Cambiar tarifas",
    BROWSE_OPEN_JOBS_USER_FEATURE_ENABLEMENT: "Ver solicitudes abiertas",
    QUOTE_JOBS_USER_FEATURE_ENABLEMENT: "Presupuestos para solicitudes",
    PRO_SUBSCRIPTIONS_USER_FEATURE_ENABLEMENT: "Suscripciones de profesional",
    SUBMIT_VERIFICATION_USER_FEATURE_ENABLEMENT: "Enviar verificación",
    PAUSE_LEADS_USER_FEATURE_ENABLEMENT: "Pausar oportunidades",
    PORTFOLIO_PHOTOS_USER_FEATURE_ENABLEMENT: "Fotos de trabajos",
    QUICK_REPLIES_USER_FEATURE_ENABLEMENT: "Respuestas rápidas",
    ACTIVITY_PAGE_USER_FEATURE_ENABLEMENT: "Página de actividad",
    DECLARE_JOB_OUTCOME_USER_FEATURE_ENABLEMENT: "Declarar el resultado de una solicitud",
    LEAD_NOTIFICATIONS_USER_FEATURE_ENABLEMENT: "Oportunidades por notificación",
    SMS_LEADS_USER_FEATURE_ENABLEMENT: "Oportunidades por SMS",
    JOB_REMINDERS_USER_FEATURE_ENABLEMENT: "Recordatorios de solicitudes",
    SWITCH_MODE_USER_FEATURE_ENABLEMENT: "Cambiar entre cliente y profesional",
    MESSAGING_USER_FEATURE_ENABLEMENT: "Mensajería",
    SEND_PHOTOS_USER_FEATURE_ENABLEMENT: "Enviar fotos",
    SHARE_LOCATION_USER_FEATURE_ENABLEMENT: "Compartir ubicación",
    CHANGE_PHONE_USER_FEATURE_ENABLEMENT: "Cambiar de número",
    CHANGE_EMAIL_USER_FEATURE_ENABLEMENT: "Cambiar de email",
    CONTACT_US_USER_FEATURE_ENABLEMENT: "Contactarnos",
    CREATE_CLIENT_PROFILE_USER_FEATURE_ENABLEMENT: "Crear un perfil de cliente",
    REPORT_USER_USER_FEATURE_ENABLEMENT: "Denunciar a alguien",
    BLOCK_USER_USER_FEATURE_ENABLEMENT: "Bloquear a alguien",
    APPEAL_DECISION_USER_FEATURE_ENABLEMENT: "Recurrir una decisión",
    SECURITY_ACTIVITY_USER_FEATURE_ENABLEMENT: "Actividad de seguridad",
    REFER_FRIENDS_USER_FEATURE_ENABLEMENT: "Invitar a amigos",
  },
  /** Every action, so the audit log names what was done instead of its id (#185). */
  actions: {
    SIGN_UP_USER_ACTION: "Registrarse",
    SIGN_IN_USER_ACTION: "Iniciar sesión",
    SIGN_OUT_USER_ACTION: "Cerrar sesión",
    UPDATE_PERSONAL_INFO_USER_ACTION: "Actualizar los datos personales",
    CHANGE_PHONE_USER_ACTION: "Cambiar el número de teléfono",
    CHANGE_EMAIL_USER_ACTION: "Cambiar la dirección de email",
    CHANGE_PASSWORD_USER_ACTION: "Cambiar la contraseña",
    SWITCH_MODE_USER_ACTION: "Cambiar entre cliente y profesional",
    CREATE_CLIENT_PROFILE_USER_ACTION: "Crear un perfil de cliente",
    UPDATE_SETTING_USER_ACTION: "Cambiar un ajuste",
    VIEW_SECURITY_ACTIVITY_USER_ACTION: "Ver la actividad de seguridad",
    REFER_FRIEND_USER_ACTION: "Invitar a un amigo",
    DELETE_ACCOUNT_USER_ACTION: "Eliminar la cuenta",
    BECOME_PRO_USER_ACTION: "Hacerse profesional",
    SUBMIT_VERIFICATION_USER_ACTION: "Enviar un documento de identidad para verificación",
    UPDATE_PRO_PROFILE_USER_ACTION: "Actualizar el perfil de profesional",
    UPDATE_RATES_USER_ACTION: "Actualizar las tarifas",
    ADD_PORTFOLIO_PHOTO_USER_ACTION: "Añadir una foto de trabajos",
    REMOVE_PORTFOLIO_PHOTO_USER_ACTION: "Quitar una foto de trabajos",
    UPDATE_LEAD_PREFERENCES_USER_ACTION: "Actualizar las preferencias de oportunidades",
    PAUSE_LEADS_USER_ACTION: "Pausar las oportunidades",
    RESUME_LEADS_USER_ACTION: "Reanudar las oportunidades",
    VIEW_OPEN_JOBS_USER_ACTION: "Ver las solicitudes abiertas",
    VIEW_ACTIVITY_USER_ACTION: "Ver la actividad",
    REQUEST_PRO_USER_ACTION: "Pedir un profesional",
    POST_OPEN_JOB_USER_ACTION: "Publicar una solicitud abierta",
    REBOOK_PRO_USER_ACTION: "Volver a contratar a un profesional",
    UPDATE_JOB_USER_ACTION: "Actualizar una solicitud",
    ADD_JOB_PHOTOS_USER_ACTION: "Añadir fotos a una solicitud",
    SCHEDULE_JOB_USER_ACTION: "Programar una solicitud",
    MARK_JOB_URGENT_USER_ACTION: "Marcar una solicitud como urgente",
    SELECT_QUOTE_USER_ACTION: "Elegir un presupuesto",
    CANCEL_JOB_USER_ACTION: "Cancelar una solicitud",
    SUBMIT_QUOTE_USER_ACTION: "Enviar un presupuesto",
    UPDATE_QUOTE_USER_ACTION: "Actualizar un presupuesto",
    WITHDRAW_QUOTE_USER_ACTION: "Retirar un presupuesto",
    ACCEPT_JOB_USER_ACTION: "Aceptar una solicitud",
    DECLINE_JOB_USER_ACTION: "Rechazar una solicitud",
    DECLARE_JOB_OUTCOME_USER_ACTION: "Declarar el resultado de una solicitud",
    SEARCH_PROS_USER_ACTION: "Buscar profesionales",
    SEARCH_PROS_NEARBY_USER_ACTION: "Buscar profesionales cercanos",
    VIEW_PRO_PROFILE_USER_ACTION: "Ver el perfil de un profesional",
    SAVE_FAVORITE_PRO_USER_ACTION: "Guardar un profesional favorito",
    REMOVE_FAVORITE_PRO_USER_ACTION: "Quitar un profesional favorito",
    SHARE_PRO_PROFILE_USER_ACTION: "Compartir el perfil de un profesional",
    OPEN_CONVERSATION_USER_ACTION: "Abrir una conversación",
    SEND_MESSAGE_USER_ACTION: "Enviar un mensaje",
    SEND_PHOTO_USER_ACTION: "Enviar una foto",
    SHARE_LOCATION_USER_ACTION: "Compartir una ubicación",
    READ_MESSAGES_USER_ACTION: "Leer los mensajes",
    SAVE_QUICK_REPLY_USER_ACTION: "Guardar una respuesta rápida",
    LEAVE_REVIEW_USER_ACTION: "Dejar una reseña",
    SUBSCRIBE_TO_PLAN_USER_ACTION: "Suscribirse a un plan",
    CANCEL_SUBSCRIPTION_USER_ACTION: "Cancelar la renovación",
    RESUME_SUBSCRIPTION_USER_ACTION: "Reanudar la renovación",
    CHANGE_PLAN_USER_ACTION: "Cambiar de plan",
    PAY_FEE_USER_ACTION: "Pagar una tarifa",
    CONTACT_SUPPORT_USER_ACTION: "Contactar con el soporte",
    REQUEST_CALLBACK_USER_ACTION: "Pedir que te llamen",
    REPORT_USER_USER_ACTION: "Denunciar a alguien",
    BLOCK_USER_USER_ACTION: "Bloquear a alguien",
    UNBLOCK_USER_USER_ACTION: "Desbloquear a alguien",
    APPEAL_DECISION_USER_ACTION: "Recurrir una decisión",
    CREATE_EXPERIMENT_STAFF_ACTION: "Iniciar un experimento",
    MOVE_EXPERIMENT_STAFF_ACTION: "Ampliar o detener un experimento",
    ADD_LEAD_STAFF_ACTION: "Añadir un contacto",
    MOVE_LEAD_STAFF_ACTION: "Hacer avanzar un contacto",
    CREATE_CAMPAIGN_STAFF_ACTION: "Preparar una campaña",
    SEND_CAMPAIGN_STAFF_ACTION: "Enviar una campaña",
    OPEN_INCIDENT_STAFF_ACTION: "Abrir una incidencia",
    UPDATE_INCIDENT_STAFF_ACTION: "Actualizar una incidencia",
    VIEW_MARKETPLACE_STAFF_ACTION: "Ver cómo va el mercado",
    VIEW_MARKETPLACE_JOB_STAFF_ACTION: "Consultar un encargo",
    SIGN_IN_STAFF_ACTION: "Iniciar sesión en la consola",
    SIGN_OUT_STAFF_ACTION: "Cerrar sesión en la consola",
    SET_PASSWORD_STAFF_ACTION: "Definir la contraseña de la consola",
    UPDATE_STAFF_SETTING_STAFF_ACTION: "Cambiar un ajuste de la consola",
    SEARCH_ACCOUNTS_STAFF_ACTION: "Buscar cuentas",
    VIEW_ACCOUNT_STAFF_ACTION: "Ver una cuenta",
    REVEAL_CONTACT_DETAILS_STAFF_ACTION: "Mostrar un número de teléfono",
    EDIT_CUSTOMER_SETTING_STAFF_ACTION: "Modificar el ajuste de un cliente",
    CORRECT_ACCOUNT_DETAILS_STAFF_ACTION: "Corregir los datos de una cuenta",
    CLAIM_CASE_STAFF_ACTION: "Tomar un expediente",
    LOG_CALL_STAFF_ACTION: "Registrar una llamada",
    REPLY_TO_CASE_STAFF_ACTION: "Responder a un cliente",
    ADD_CASE_NOTE_STAFF_ACTION: "Añadir una nota interna",
    CLOSE_CASE_STAFF_ACTION: "Cerrar un expediente",
    REASSIGN_CASE_STAFF_ACTION: "Reasignar un expediente",
    LINK_CASE_CUSTOMER_STAFF_ACTION: "Vincular un cliente a un expediente",
    START_ON_BEHALF_SESSION_STAFF_ACTION: "Empezar a actuar en nombre de un cliente",
    END_ON_BEHALF_SESSION_STAFF_ACTION: "Dejar de actuar en nombre de un cliente",
    VIEW_VERIFICATION_STAFF_ACTION: "Ver una verificación",
    APPROVE_VERIFICATION_STAFF_ACTION: "Aprobar una verificación",
    REJECT_VERIFICATION_STAFF_ACTION: "Rechazar una verificación",
    VIEW_ID_IMAGES_STAFF_ACTION: "Ver las imágenes de identidad",
    APPROVE_PRO_STAFF_ACTION: "Aprobar a un profesional",
    REJECT_PRO_STAFF_ACTION: "Rechazar a un profesional",
    VIEW_PAYMENTS_STAFF_ACTION: "Ver los pagos",
    ISSUE_REFUND_STAFF_ACTION: "Emitir un reembolso",
    ISSUE_CREDIT_STAFF_ACTION: "Emitir un crédito",
    WAIVE_FEE_STAFF_ACTION: "Anular una tarifa",
    MARK_PAYMENT_PAID_STAFF_ACTION: "Marcar una tarifa como pagada",
    APPROVE_PAYMENT_REQUEST_STAFF_ACTION: "Aprobar una petición",
    REJECT_PAYMENT_REQUEST_STAFF_ACTION: "Rechazar una petición",
    SETTLE_REFUND_STAFF_ACTION: "Liquidar un reembolso",
    SET_PLAN_PRICE_STAFF_ACTION: "Fijar el precio de un plan",
    CREATE_PROMO_STAFF_ACTION: "Crear una promoción",
    END_PROMO_STAFF_ACTION: "Terminar una promoción",
    CREATE_DISCOUNT_STAFF_ACTION: "Crear un descuento",
    END_DISCOUNT_STAFF_ACTION: "Terminar un descuento",
    EXTEND_SUBSCRIPTION_STAFF_ACTION: "Alargar una suscripción",
    END_SUBSCRIPTION_STAFF_ACTION: "Terminar una suscripción",
    RECONCILE_PAYMENTS_STAFF_ACTION: "Conciliar los pagos",
    EXPORT_PAYMENTS_STAFF_ACTION: "Exportar los pagos",
    OPEN_SAFETY_REPORT_STAFF_ACTION: "Abrir una denuncia de seguridad",
    ADD_REPORT_EVIDENCE_STAFF_ACTION: "Añadir pruebas a una denuncia",
    SET_REPORT_SEVERITY_STAFF_ACTION: "Fijar la gravedad de una denuncia",
    SUSPEND_PENDING_INVESTIGATION_STAFF_ACTION: "Suspender una cuenta mientras dura la investigación",
    LIFT_SUSPENSION_STAFF_ACTION: "Levantar una suspensión",
    ISSUE_VERDICT_STAFF_ACTION: "Emitir un veredicto",
    BAN_PERMANENTLY_STAFF_ACTION: "Vetar una cuenta de forma definitiva",
    DECIDE_APPEAL_STAFF_ACTION: "Resolver un recurso",
    REFER_TO_POLICE_STAFF_ACTION: "Remitir un expediente a la policía",
    SHARE_DATA_WITH_POLICE_STAFF_ACTION: "Compartir datos con la policía",
    PLACE_LEGAL_HOLD_STAFF_ACTION: "Aplicar una congelación de pruebas",
    RELEASE_LEGAL_HOLD_STAFF_ACTION: "Levantar una congelación de pruebas",
    HIDE_REVIEW_STAFF_ACTION: "Ocultar una reseña",
    RESTORE_REVIEW_STAFF_ACTION: "Restaurar una reseña",
    SEND_SMS_STAFF_ACTION: "Enviar un SMS",
    SEND_BULK_SMS_STAFF_ACTION: "Enviar un SMS a muchas personas",
    EDIT_SMS_TEMPLATE_STAFF_ACTION: "Modificar una plantilla de SMS",
    SET_USER_FEATURE_ENABLEMENT_STAFF_ACTION: "Activar o desactivar una función de cliente",
    CREATE_RULE_VERSION_STAFF_ACTION: "Modificar una regla de la empresa",
    EDIT_PRICING_STAFF_ACTION: "Modificar los tramos de tarifas",
    EDIT_CATEGORIES_STAFF_ACTION: "Modificar los oficios",
    INVITE_STAFF_STAFF_ACTION: "Invitar a un miembro del equipo",
    DEACTIVATE_STAFF_STAFF_ACTION: "Desactivar a un miembro del equipo",
    REACTIVATE_STAFF_STAFF_ACTION: "Reactivar a un miembro del equipo",
    END_STAFF_SESSION_STAFF_ACTION: "Cerrar las sesiones de un miembro del equipo",
    REQUEST_PERMISSION_STAFF_ACTION: "Pedir un permiso",
    DECIDE_PERMISSION_REQUEST_STAFF_ACTION: "Responder a una solicitud de permiso",
    UPDATE_ACTION_ENABLEMENT_STAFF_ACTION: "Modificar la activación de una acción",
    REQUEST_TIME_OFF_STAFF_ACTION: "Pedir vacaciones",
    DECIDE_TIME_OFF_STAFF_ACTION: "Decidir una solicitud de vacaciones",
    SET_EMPLOYMENT_STAFF_ACTION: "Editar un expediente laboral",
    OPEN_JOB_STAFF_ACTION: "Abrir una vacante",
    EDIT_JOB_STAFF_ACTION: "Editar una vacante",
    MOVE_CANDIDATE_STAFF_ACTION: "Avanzar a un candidato",
    OPEN_PAYROLL_STAFF_ACTION: "Abrir un mes de nómina",
    EDIT_PAYROLL_LINE_STAFF_ACTION: "Retener o liberar una línea de nómina",
    CLOSE_PAYROLL_STAFF_ACTION: "Cerrar un mes de nómina",
    OPEN_REVIEW_CYCLE_STAFF_ACTION: "Abrir un ciclo de evaluación",
    WRITE_REVIEW_STAFF_ACTION: "Escribir una evaluación",
    EDIT_COURSE_STAFF_ACTION: "Añadir o cambiar un curso",
    ENROL_IN_COURSE_STAFF_ACTION: "Inscribirse en un curso",
    CREATE_TEAM_STAFF_ACTION: "Crear un equipo",
    EDIT_TEAM_STAFF_ACTION: "Editar un equipo",
    SET_TEAM_MEMBERSHIP_STAFF_ACTION: "Definir quién está en el equipo",
    CREATE_ROLE_STAFF_ACTION: "Crear un rol",
    EDIT_ROLE_STAFF_ACTION: "Modificar un rol",
    SET_STAFF_PERMISSION_STAFF_ACTION: "Conceder o retirar un permiso",
    SET_STAFF_FEATURE_ENABLEMENT_STAFF_ACTION: "Conceder o retirar una función",
    ASSIGN_ROLE_STAFF_ACTION: "Asignar un rol",
    REMOVE_ROLE_STAFF_ACTION: "Quitar un rol",
    VIEW_AUDIT_LOG_STAFF_ACTION: "Consultar el registro de auditoría",
    VIEW_SENSITIVE_AUDIT_VALUES_STAFF_ACTION: "Ver los valores sensibles de la auditoría",
    VIEW_HEALTH_DASHBOARD_STAFF_ACTION: "Ver el panel de salud",
    EXPIRE_JOB_SYSTEM_ACTION: "Caducar una solicitud sin respuesta",
    EXPIRE_QUOTE_SYSTEM_ACTION: "Caducar un presupuesto",
    CLOSE_OTHER_QUOTES_SYSTEM_ACTION: "Cerrar los demás presupuestos",
    OPEN_CONVERSATION_ON_QUOTE_SYSTEM_ACTION: "Abrir una conversación sobre un presupuesto",
    NOTIFY_USER_SYSTEM_ACTION: "Enviar una notificación",
    NOTIFY_NEW_LEAD_SYSTEM_ACTION: "Avisar a un profesional de una nueva oportunidad",
    SEND_LEAD_SMS_SYSTEM_ACTION: "Enviar una oportunidad por SMS",
    NOTIFY_JOB_REMINDER_SYSTEM_ACTION: "Enviar un recordatorio de solicitud",
    CONFIRM_FEE_PAYMENT_SYSTEM_ACTION: "Confirmar el pago de una tarifa",
    FAIL_FEE_PAYMENT_SYSTEM_ACTION: "Registrar el pago fallido de una tarifa",
    ACTIVATE_SUBSCRIPTION_SYSTEM_ACTION: "Activar una suscripción",
    SUSPEND_SUBSCRIPTION_SYSTEM_ACTION: "Suspender una suscripción",
    RENEW_SUBSCRIPTION_SYSTEM_ACTION: "Renovar una suscripción",
    EXPIRE_SUBSCRIPTION_SYSTEM_ACTION: "Terminar una suscripción caducada",
    REMIND_SUBSCRIPTION_EXPIRY_SYSTEM_ACTION: "Recordar a un profesional que su plan termina",
    EXPIRE_SETTING_VALUE_SYSTEM_ACTION: "Caducar el valor de un ajuste",
    DELETE_ID_IMAGES_SYSTEM_ACTION: "Eliminar las imágenes de identidad",
    FLAG_BANNED_DOCUMENT_SYSTEM_ACTION: "Marcar un documento vetado",
    SUSPEND_ON_CRITICAL_REPORT_SYSTEM_ACTION: "Suspender tras una denuncia crítica",
  },
  /** The settings a person chooses for themselves, by settingId. */
  settings: {
    THEME_USER_SETTING: "Tema",
    COLOR_VIBE_USER_SETTING: "Color",
    LANGUAGE_USER_SETTING: "Idioma",
    LOW_DATA_MODE_USER_SETTING: "Modo de datos reducidos",
    NEW_LEAD_NOTIFICATION_USER_SETTING: "Avisarme de nuevas oportunidades",
    QUOTE_RECEIVED_NOTIFICATION_USER_SETTING: "Avisarme cuando llegue un presupuesto",
    NEW_LEAD_SMS_USER_SETTING: "Enviar las nuevas oportunidades por SMS",
    QUOTE_RECEIVED_SMS_USER_SETTING: "Enviar un presupuesto por SMS",
    LEAD_TRADES_USER_SETTING: "Oficios para los que quiero oportunidades",
    LEAD_SERVICE_AREA_USER_SETTING: "Dónde trabajo",
    LEAD_RADIUS_USER_SETTING: "Hasta dónde me desplazo",
    LEAD_DAYS_USER_SETTING: "Días en que acepto trabajo",
    URGENT_JOBS_USER_SETTING: "Solicitudes urgentes",
    CONSOLE_THEME_STAFF_SETTING: "Tema de la consola",
    CONSOLE_LANGUAGE_STAFF_SETTING: "Idioma de la consola",
  },
  /** The grid's section titles. */
  categories: {
    appearance: "Apariencia",
    notifications: "Notificaciones",
    leads: "Oportunidades",
    discovery: "Búsqueda",
    jobs: "Solicitudes",
    profile: "Perfil",
    accounts: "Cuentas",
    support: "Expedientes",
    onBehalf: "En nombre de un cliente",
    onboarding: "Verificación",
    payments: "Pagos",
    safety: "Confianza y seguridad",
    messaging: "Mensajes",
    configuration: "Configuración",
    staff: "Equipo y accesos",
    audit: "Auditoría",
  },
};
